import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserServices from '../../services/UserServices';
import { FaArrowLeft } from "react-icons/fa";

function AddVendor() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [loadingCities, setLoadingCities] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const handleBack = () => {
        navigate(-1);
    };
    const [formValues, setFormValues] = useState({
        name: '',
        mobileNo: '',
        email: '',
        password: '',
        businessName: '',
        address: '',
        cityName: '',
        stateName: '',
        pincode: '',
        image: ""
    });
    const [states, setStates] = useState([]);
    const [filteredCities, setFilteredCities] = useState([]);
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        console.log("Changing field:", name, "to value:", value);

        setFormValues(prev => ({
            ...prev,
            [name]: value
        }));

        // If state is changed, fetch cities for that state
        if (name === 'stateName') {
            // Reset city when state changes
            setFormValues(prev => ({
                ...prev,
                cityName: ''
            }));
            setFilteredCities([]);

            if (value) {
                setLoadingCities(true);
                try {
                    // Find the selected state object to get its ID
                    const selectedState = states.find(state => state.name === value);
                    console.log("Selected state:", selectedState); // Debug log
                    if (selectedState && selectedState._id) {
                        // Fetch cities based on state ID
                        UserServices.getCities(selectedState._id).then(response => {
                            console.log("Cities response:", response); // Debug log
                            if (response.status && response.data) {
                                setFilteredCities(response.data);
                            }
                        }).catch(error => {
                            console.error("Error fetching cities:", error);
                        }).finally(() => {
                            setLoadingCities(false);
                        });
                    } else {
                        setLoadingCities(false);
                    }
                } catch (error) {
                    console.error("Error fetching cities:", error);
                    setLoadingCities(false);
                }
            }
        }
    };

    useEffect(() => {
        // Fetch states on component mount
        UserServices.getState().then(res => {
            console.log("States response:", res); // Debug log
            if (res.status && res.data) {
                setStates(res.data);
            }
        }).catch(error => {
            console.error("Error fetching states:", error);
        });
    }, []);

    const handleNumberInput = (e) => {
        if (!/^[0-9]$/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "Tab") {
            e.preventDefault();
        }
    };

    const handleNumberPaste = (e) => {
        const pasteData = e.clipboardData.getData('text');
        if (!/^\d+$/.test(pasteData)) {
            e.preventDefault();
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!/^\d{10}$/.test(formValues.mobileNo)) {
            alert("Mobile number must be exactly 10 digits");
            return;
        }
        if (!/^\d{6}$/.test(formValues.pincode)) {
            alert("Pincode must be exactly 6 digits");
            return;
        }
        if (formValues.password.length < 6) {
            alert("Password must be at least 6 characters");
            return;
        }
        if (!formValues.stateName) {
            alert("Please select a state");
            return;
        }
        if (!formValues.cityName) {
            alert("Please select a city");
            return;
        }

        setLoading(true);

        try {
            const payload = {
                ...formValues,
                mobileNo: Number(formValues.mobileNo),
                pincode: formValues.pincode
            };
            const res = await UserServices.addVendor(payload);
            // alert('Vendor created successfully!');

            // setFormValues({
            //     name: '', mobileNo: '', email: '', password: '',
            //     businessName: '', address: '', cityName: '',
            //     stateName: '', pincode: '', image: ""
            // });
            // setFilteredCities([]);

            // navigate('/vendor');


            if (res?.status === true) {
                alert(res?.message);
                setFormValues({
                    name: '', mobileNo: '', email: '', password: '',
                    businessName: '', address: '', cityName: '',
                    stateName: '', pincode: '', image: ""
                });
                setFilteredCities([]);
                navigate('/vendor');
            } else {
                alert(res?.message || "Something went wrong!");
            }
        } catch (error) {
            console.error('Failed to create Vendor:', error);
            const errorMsg = error?.response?.data?.message
                || error?.response?.data?.error
                || error.message
                || 'Failed to create Vendor. Please try again.';
            alert(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="right_col" role="main">
                <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
                    <div className="my-auto">
                        <h5 className="page-title fs-21 mb-1">Owner Add</h5>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <a href="javascript:void(0);">Home</a>
                                </li>
                                <li className="breadcrumb-item active">Owner</li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                        <div className="pe-1 mb-xl-0">
                            <button
                                onClick={handleBack}
                                className="btn btn-sm btn-outline-secondary d-flex align-items-center me-3"
                                style={{ cursor: 'pointer' }}
                            >
                                <FaArrowLeft className="me-1" /> Back
                            </button>
                        </div>
                    </div>
                </div>

                <div className="container-box">
                    <div className="container-box-inner table-reponsive-tabe">
                        <div className="page-details">
                            <form onSubmit={handleSubmit}>
                                <div className="input-field">
                                    <label>Name<span className="red">*</span></label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formValues.name}
                                        onChange={handleInputChange}
                                        className="form-control"
                                      
                                        placeholder="Name"
                                    />
                                </div>
                                <div className="input-field">
                                    <label>Mobile No<span className="red">*</span></label>
                                    <input
                                        type="text"
                                        name="mobileNo"
                                        value={formValues.mobileNo}
                                        onChange={handleInputChange}
                                        onKeyDown={handleNumberInput}
                                        onPaste={handleNumberPaste}
                                        className="form-control"
                                        maxLength="10"
                                        placeholder="Mobile Number"
                                    />
                                </div>
                                <div className="input-field">
                                    <label>Email<span className="red">*</span></label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formValues.email}
                                        onChange={handleInputChange}
                                        autoComplete="new-email"
                                        className="form-control"
                                     
                                        placeholder="Email"
                                    />
                                </div>

                                <div className="input-field">
                                    <label>Password<span className="red">*</span></label>
                                    <input
                                        type="password"
                                        name="password"
                                        value={formValues.password}
                                        onChange={handleInputChange}
                                        autoComplete="new-password"
                                        className="form-control"
                               
                                        placeholder="Password"
                                        minLength="6"
                                    />
                                </div>

                                <div className="input-field">
                                    <label>Business Name<span className="red">*</span></label>
                                    <input
                                        type="text"
                                        name="businessName"
                                        value={formValues.businessName}
                                        onChange={handleInputChange}
                                        className="form-control"
                                      
                                        placeholder="Business Name"
                                    />
                                </div>

                                <div className="input-field">
                                    <label>Address<span className="red">*</span></label>
                                    <input
                                        type="text"
                                        name="address"
                                        value={formValues.address}
                                        onChange={handleInputChange}
                                        className="form-control"
                                     
                                        placeholder="Address"
                                    />
                                </div>

                                {/* State Dropdown */}
                                <div className="input-field">
                                    <label>State<span className="red">*</span></label>
                                    <select
                                        name="stateName"
                                        className="form-control"
                                        value={formValues.stateName}
                                        onChange={handleInputChange}
                                     
                                    >
                                        <option value="">Select State</option>
                                        {states.map(state => (
                                            <option key={state._id} value={state.name}>
                                                {state.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* City Dropdown */}
                                <div className="input-field">
                                    <label>City<span className="red">*</span></label>
                                    <select
                                        name="cityName"
                                        className="form-control"
                                        value={formValues.cityName}
                                        onChange={handleInputChange}
                                     
                                        disabled={!formValues.stateName || loadingCities}
                                    >
                                        <option value="">
                                            {loadingCities ? "Loading cities..." : "Select City"}
                                        </option>
                                        {filteredCities.map(city => (
                                            <option key={city._id} value={city.name}>
                                                {city.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="input-field">
                                    <label>Pincode<span className="red">*</span></label>
                                    <input
                                        type="text"
                                        name="pincode"
                                        value={formValues.pincode}
                                        onChange={handleInputChange}
                                        onKeyDown={handleNumberInput}
                                        onPaste={handleNumberPaste}
                                        className="form-control"
                                        maxLength="6"
                                        placeholder="Pincode"
                                    />
                                </div>
                                <input
                                    type="file"
                                    name="image"
                                    className="form-control"
                                    accept="image/*"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            setFormValues(prev => ({
                                                ...prev,
                                                image: file
                                            }));
                                            setImagePreview(URL.createObjectURL(file));
                                        } else {
                                            setFormValues(prev => ({
                                                ...prev,
                                                image: ""
                                            }));
                                            setImagePreview(null);
                                        }
                                    }}
                                />
                                {imagePreview && (
                                    <div style={{ marginTop: "10px" }}>
                                        <img
                                            src={imagePreview}
                                            alt="Preview"
                                            style={{ width: "150px", height: "150px", objectFit: "cover", borderRadius: "8px", border: "1px solid #ccc" }}
                                        />
                                    </div>
                                )}
                                <button
                                    type="submit"
                                    className="submit-green-btn"
                                    disabled={loading}
                                >
                                    {loading ? "Creating Vendor..." : "SUBMIT"}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddVendor;